import PropTypes from 'prop-types';

export default PropTypes.shape({
  page: PropTypes.number,
  size: PropTypes.number,
  totalPages: PropTypes.number,
  totalItems: PropTypes.number,
});
